module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "loading": _vm.loading,
      "height": _vm.result.length > 0 ? 700 : ''
    }
  }, [_c('v-card-title', [_c('v-chip', {
    staticClass: "mr-2",
    attrs: {
      "color": "green",
      "dark": ""
    }
  }, [_vm._v("Neu")]), _vm._v("\n      " + _vm._s(_vm.rechnungen.length) + " Rechnung versenden\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "my-4"
  }, [(_vm.result.length < _vm.versendeRechnung.gesamt || _vm.versendeRechnung.gesamt === 0) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "warning",
      "dismissible": ""
    }
  }, [_vm._v("\n            Achtung! Diese Funktion ist noch neu und im Test. Bitte nur in Absprache mit Benedikt verwenden.\n            ")]), _vm._v(" "), _c('p', [_vm._v("Durch diese Funktion wird für jede Rechnung")]), _vm._v(" "), _c('li', {
    staticClass: "pt-1"
  }, [_vm._v("ein PDF generiert, welches auf dem Server gespeichert ist.")]), _vm._v(" "), _c('li', {
    staticClass: "pt-1"
  }, [_vm._v("eine Mail an den Rechnungsempfänger geschickt.")]), _vm._v(" "), _c('li', {
    staticClass: "pt-1"
  }, [_vm._v("die Rechnung als \"offen\" bzw \"gezahlt\" (bei SEPA) markiert.")]), _vm._v(" "), _c('li', {
    staticClass: "pt-1"
  }, [_vm._v("eine SEPA Datei wird generiert und heruntergeladen.")]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v("\n            Der Versand kann mehrere Minuten dauern. "), _c('br'), _vm._v("\n            Das Fenster darf nicht geschlossen werden.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "rounded": "",
      "disabled": _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.rechnungVersenden(_vm.rechnungen)
      }
    },
    scopedSlots: _vm._u([{
      key: "loader",
      fn: function() {
        return [_c('span', {
          staticClass: "ml-2"
        }, [_vm._v(_vm._s(_vm.$filters.date(_vm.timer, "mmss")))])]
      },
      proxy: true
    }], null, false, 870740261)
  }, [_vm._v("\n              Rechnungen versenden\n            ")])], 1), _vm._v(" "), (_vm.result.length !== _vm.versendeRechnung.gesamt && (_vm.result.length > 0 || _vm.loading)) ? _c('div', {
    staticClass: "mt-10"
  }, [(_vm.createPDF.gesamt > 0) ? _c('v-progress-linear', {
    staticClass: "rounded mb-4",
    attrs: {
      "value": (_vm.createPDF.erledigt / _vm.createPDF.gesamt) * 100,
      "color": "success",
      "height": "24",
      "stream": "",
      "buffer-value": "0"
    }
  }, [_vm._v("\n              Rechnungs-PDF wird generiert: " + _vm._s(_vm.createPDF.erledigt) + " von " + _vm._s(_vm.createPDF.gesamt) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "rounded",
    attrs: {
      "value": (_vm.versendeRechnung.erledigt / _vm.versendeRechnung.gesamt) * 100,
      "color": "success",
      "height": "24",
      "stream": "",
      "buffer-value": "0"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.versendeRechnung.erledigt) + " von " + _vm._s(_vm.versendeRechnung.gesamt) + " gesendet\n            ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Diese Rechnungen werden gesendet:")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "height": "400px"
    }
  }, [_c('tbody', _vm._l((_vm.rechnungen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.rechnungsnummer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbrID, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.rechnung_art))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))])])
  }), 0)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.result.length > 0) ? _c('v-row', [_c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-chip', {
    attrs: {
      "label": ""
    }
  }, [_vm._v("Dauer: " + _vm._s(_vm.$filters.date(_vm.timer, "mmss")))])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 pb-0",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": -90,
      "value": (_vm.result.filter(function (item) { return !item.error; }).length / _vm.versendeRechnung.gesamt) * 100,
      "color": "success",
      "size": "64",
      "width": "8"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "success",
      "size": "36"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('strong', {
    staticClass: "ml-4 success--text"
  }, [_vm._v(_vm._s(_vm.result.filter(function (item) { return !item.error; }).length) + " Rechnungen wurden erfolgreich gesendet.")])], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "d-flex justify-center py-0"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showLogFilter = false
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_down")]), _vm._v("Anzeigen")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 pb-0",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": -90,
      "value": (_vm.result.filter(function (item) { return item.error; }).length / _vm.versendeRechnung.gesamt) * 100,
      "color": "error",
      "size": "64",
      "width": "8"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "error",
      "size": "36"
    }
  }, [_vm._v("error")])], 1), _vm._v(" "), _c('strong', {
    staticClass: "ml-4 error--text"
  }, [_vm._v(_vm._s(_vm.result.filter(function (item) { return item.error; }).length) + " Rechnungen konnten nicht gesendet werden.")])], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "d-flex justify-center py-0"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showLogFilter = true
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_down")]), _vm._v("Anzeigen")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.result.filter(function (item) { return item.error === _vm.showLogFilter; }),
      "expanded": _vm.expanded,
      "single-expand": "",
      "dense": "",
      "items-per-page": -1,
      "height": "370",
      "item-key": "rechnung",
      "show-expand": "",
      "hide-default-footer": ""
    },
    on: {
      "update:expanded": function($event) {
        _vm.expanded = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.error",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": item.error ? 'error' : 'success'
          }
        }, [_vm._v("\n                    " + _vm._s(item.error ? "warning" : "check") + "\n                  ")])], 1)]
      }
    }, {
      key: "item.rechnung",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "d-flex align-center justify-space-between",
          attrs: {
            "width": "100%"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.versendeRechnung.rechnungen.find(function (a) { return a.id === item.rechnung; }).rechnungsnummer) + "\n                  "), (item.error) ? _c('span', [_c('v-btn', {
          attrs: {
            "outlined": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.erneutVersuchen(item)
            }
          }
        }, [_vm._v("Erneut senden")])], 1) : _vm._e()])]
      }
    }, {
      key: "expanded-item",
      fn: function(ref) {
        var headers = ref.headers;
        var item = ref.item;

        return [_c('td', {
          staticClass: "py-2",
          attrs: {
            "colspan": 2
          }
        }, [_c('v-list', {
          attrs: {
            "dense": ""
          }
        }, _vm._l((item.log), function(log, j) {
          return _c('v-list-item', {
            key: j
          }, [_c('v-list-item-icon', [_c('v-icon', {
            attrs: {
              "color": log.error ? 'error' : 'success'
            }
          }, [_vm._v("\n                          " + _vm._s(log.error ? "warning" : "check") + "\n                        ")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(log.message))]), _vm._v(" "), (log.error) ? _c('v-list-item-subtitle', [_vm._v("Funktion: " + _vm._s(log.function))]) : _vm._e(), _vm._v(" "), (log.error) ? _c('v-list-item-subtitle', [_vm._v("data: " + _vm._s(log.data))]) : _vm._e()], 1)], 1)
        }), 1)], 1)]
      }
    }], null, false, 3578828308)
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e671e84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/dialogRechnungenVersenden.vue
// module id = 800
// module chunks = 15